<div class="page">
  <mat-toolbar class="bar" color="primary">
    <div class="bar__logo">
      <img class="bar__logo-img" src="./assets/images/home/logo-yep.png">
      <img class="bar__logo-icon" src="./assets/images/home/icon.png">
    </div>
    <button (click)="toContact()" mat-button class="bar__item" aria-label="contact us">
      Contact Us
    </button>
    <button (click)="toLogin()" mat-button class="bar__item" aria-label="login">
      Login
    </button>
    <button (click)="toDemo()"  mat-flat-button color="primary" class="bar__item" aria-label="book a demo">
      Book a Demo
    </button>
  </mat-toolbar>

  <div class="hero">
    <div class="hero__title">
      <span class="hero__title-left">Elevate Your Real Estate Sales with</span>
      <span class="hero__title-right">YepHome</span>
    </div>

    <div class="hero__notes">
     Find projects, manage commissions, sell faster and manage leads in real time.
    </div>

    <div class="hero__demo" (click)="toDemo()">
      Request a Demo
    </div>

    <div class="hero__video">
      <iframe src="https://fast.wistia.net/embed/iframe/kbb41whhfs?seo=true&videoFoam=true" title="Agents wiz subtitles Video" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="100%"></iframe>
    </div>
  </div>

  <div class="partners">
    <div class="partners__title">
      <span class="partners__title-left">OUR</span>
      <span class="partners__title-right">PARTNERS</span>
    </div>
    <img class="partners__img" src="./assets/images/home/partner-img.png" />
  </div>

  <div class="partition partition--color-grey">
    <div class="card">
      <div class="card__content card__content--color-grey">
        <h1 class="card__title">
          Discover new projects
        </h1>
        <div class="card__text">
          <div class="card__text-row">
            <mat-icon class="card__text-icon">group</mat-icon>
            <span>Expand your network by linking with developers and master agents to find new projects to sell.</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">update</mat-icon>
            <span>Stay updated with real-time information on new projects</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">trending_up</mat-icon>
            <span>Broaden your project portfolio and enhance your sales opportunities</span>
          </div>
        </div>
        <div class="card__foot">
          <div class="card__foot-tags">
            <span class="card__foot-tag card__foot-tag--color-grey">Link With Developers</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Realtime Updates</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Increase Portfolio</span>
          </div>
        </div>
      </div>
      <div class="card__photo">
        <img class="card__image" src="./assets/images/home/discover-new-projects.png"/>
      </div>
    </div>
  </div>

  <div class="partition partition--color-peach">
    <div class="card">
      <div class="card__photo">
        <img class="card__image card__image--radius-left" src="./assets/images/home/free-project-listings.png"/>
      </div>
      <div class="card__content card__content--color-peach card__content--radius-right">
        <h1 class="card__title">
          Free project listings
        </h1>
        <div class="card__text">
          <div class="card__text-row">
            <mat-icon class="card__text-icon">real_estate_agent</mat-icon>
            <span>Create your own project listings to attract new customer leads</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">smart_toy</mat-icon>
            <span>Use our new AI functionality to constantly refresh your property descriptions helping you generate more leads.</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">rocket_launch</mat-icon>
            <span>Boost the amount of verified leads you obtain, using our YepHome Marketing service.</span>
          </div>
        </div>
        <div class="card__foot">
          <div class="card__foot-tags">
            <span class="card__foot-tag card__foot-tag--color-grey">Project Listings</span>
            <span class="card__foot-tag card__foot-tag--color-grey">AI Property Descriptions</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Boost Leads</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="partition partition--color-grey">
    <div class="card">
      <div class="card__content card__content--color-grey">
        <h1 class="card__title">
          Connect and Sell
        </h1>
        <div class="card__text">
          <div class="card__text-row">
            <mat-icon class="card__text-icon">connect_without_contact</mat-icon>
            <span>Connect with over 1000 registered agents with an active buyer network.</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">handshake</mat-icon>
            <span>Let our vast network of real estate agents manage and sell your projects, saving you time and resources.</span>
          </div>
          <div class="card__text-row">
            <mat-icon class="card__text-icon">bar_chart</mat-icon>
            <span>Track the progress of EOI's to final settlement and manage agency's performance easily.</span>
          </div>
        </div>
        <div class="card__foot">
          <div class="card__foot-tags">
            <span class="card__foot-tag card__foot-tag--color-grey">Connect With Channel Agents</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Project Management</span>
            <span class="card__foot-tag card__foot-tag--color-grey">Track Performance</span>
          </div>
        </div>
      </div>
      <div class="card__photo">
        <img class="card__image" src="./assets/images/home/connect-and-sell.png"/>
      </div>
    </div>
  </div>

  <app-new-footer></app-new-footer>
</div>
